import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  onSelect({target: {id, name}}) {
    this.dispatch("update", {detail: { name, value: id }});
  }
}
